import React, { lazy } from "react";

export const EditVehicleAddressLFSTAMetadata = {
  name: "Edit Vehicle Address",
  id: "edit_vehicle_address",
  component: lazy(() => import("./EditAddress")),
  route: "/edit_vehicle_address",
  Breadcrumbs: true,
};
